export default {
  props: {
    variant: {
      type: String,
      default: 'base'
    },
    size: {
      type: String,
      default: 'md'
    },
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      variants: {
        base: {
          base: 'bg-primary autofill:bg-secondary text-secondary placeholder-primary',
          flat: 'bg-secondary autofill:bg-secondary text-secondary placeholder-primary'
        },
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900'
      },
      sizes: {
        sm: 'h-8 text-xs px-3',
        md: 'h-10 text-sm px-4',
        lg: 'h-12 text-sm px-5'
      }
    }
  },
  computed: {
    classes () {
      const variant = this.variant
      const variants = this.variants

      const classes = []

      if (this.flat) {
        classes.push(variants[variant]?.flat || variants[variant] || variants.base || '')
      } else {
        classes.push(variants[variant]?.base || variants[variant] || variants.base || '')
      }

      const size = this.size
      const sizes = this.sizes

      classes.push(sizes[size] || sizes.md)

      return classes
    },
    handlers () {
      return {
        blur: this.onBlur,
        focus: this.onFocus,
        keyup: this.onKeyUp,
        keydown: this.onKeyDown
      }
    }
  },
  methods: {
    onBlur (e) {
      this.$emit('blur', e)
    },
    onFocus (e) {
      this.$emit('focus', e)
    },
    onKeyUp (e) {
      this.$emit('keyup', e)
    },
    onKeyDown (e) {
      this.$emit('keydown', e)
    }
  }
}
